import { createContext } from 'react'

import {
  ComponentStyles,
  ImportantComponentStyles,
  Theme,
} from '@pijma/hero-types'

export interface ThemeContextType<ITokens> {
  theme?: Theme<ITokens>
  componentStyles?: ComponentStyles<ITokens>
  important?: ImportantComponentStyles<ITokens>
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const ThemeContext = createContext<ThemeContextType<any> | undefined>(
  undefined,
)
